import { useState, useEffect, useContext } from "react";
import Premissions from "./Premissions";
import { request } from "../../../request";
import { MainContext } from "../../../MainContext";
import CollapsableBox from "../../CollapsibleBox/CollapsableBox";
import { Button } from "@mui/material";
import Swal from "sweetalert2";

const UsersList = ({ darkMode, users, texts }) => {
    const [userPermissions, setUserPermissions] = useState({});
    const [defaultPremissions, setDefaultPremissions] = useState({});

    const { joined_transactions, boxOpener, openState, updateUsers } = useContext(MainContext);

    useEffect(() => {
        const newPremissions = {};
        users.forEach((user) => {
            newPremissions[user._id] = { ...JSON.parse(JSON.stringify(defaultPremissions)) } || {};
            Object.entries(newPremissions[user._id]).map(([key1, obj]) => {
                const userObj = user.premissions[key1];
                if (userObj) {
                    Object.entries(obj).map(([key, value]) => {
                        const userValue = userObj[key];
                        if (userValue !== undefined) {
                            if (Array.isArray(value)) {
                                value.forEach((e, i) => {
                                    newPremissions[user._id][key1][key][i] = {
                                        ...newPremissions[user._id][key1][key][i],
                                        allowed: userValue.find((e1) => e.name === e1.name)?.allowed,
                                    };
                                });
                            } else {
                                newPremissions[user._id][key1][key] = userValue;
                            }
                        }
                    });
                }
            });
        });
        setUserPermissions(newPremissions);
    }, [users, defaultPremissions]);

    const handleEditUserPermissions = async (userId, permissions) => {
        setUserPermissions({
            ...userPermissions,
            [userId]: permissions,
        });
        const permissionsToUpdate = permissions;
        if (permissionsToUpdate) {
            await request.post(`/user/edit/${userId}`, {
                premissions: permissionsToUpdate,
            });
        } else {
            console.warn(`No permissions found for user with ID: ${userId}`);
        }
    };

    useEffect(() => {
        request.get("/user/premissions").then((res) => {
            setDefaultPremissions(res.data);
        });
    }, []);

    return (
        <div className="px-40 flex flex-1 justify-center py-5">
            <div className="layout-content-container flex flex-col max-w-[1260px] flex-1">
                <h2 className="text-[#111418] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5" style={{ color: darkMode ? "white" : "black" }}>
                    {texts.user.users}
                </h2>
                <div className="px-4 py-3 @container">
                    {users.map((user) => (
                        <CollapsableBox title={`User: ${user.login} Email: ${user.email}`} isOpen={openState[user._id]} setIsOpen={() => boxOpener(user._id)}>
                            <div style={{ padding: "15px" }}>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    sx={{
                                        mt: 5,
                                        mb: 3,
                                        color: "white",
                                        borderColor: "white",
                                        "&:hover": {
                                            backgroundColor: "white",
                                            color: "black",
                                        },
                                    }}
                                    onClick={async () => {
                                        const result = await Swal.fire({
                                            title: "Are you sure?",
                                            text: "This action will revoke the password of the user!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonText: "Yes, revoke!",
                                            cancelButtonText: "Cancel",
                                        });

                                        if (result.isConfirmed) {
                                            try {
                                                await request.post("/user/revoke-password/", { email: user.email });
                                                Swal.fire("Revoked!", "The password has been revoked. Ask user to check their email", "success");
                                            } catch (err) {
                                                Swal.fire("Error!", "Failed to revoke password.", "error");
                                            }
                                        }
                                    }}
                                >
                                    Revoke password
                                </Button>
                                <br />
                                <Button
                                    variant="outlined"
                                    component="label"
                                    sx={{
                                        mt: 5,
                                        mb: 3,
                                        color: "red",
                                        borderColor: "white",
                                        "&:hover": {
                                            backgroundColor: "white",
                                            color: "black",
                                        },
                                    }}
                                    onClick={async () => {
                                        const result = await Swal.fire({
                                            title: "Are you sure?",
                                            text: "This action will delete the user!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonText: "Yes, delete!",
                                            cancelButtonText: "Cancel",
                                        });

                                        if (result.isConfirmed) {
                                            try {
                                                await request.post("/user/delete/" + user._id);
                                                Swal.fire("Deleted!", "The user has been deleted.", "success");
                                                updateUsers();
                                            } catch (err) {
                                                Swal.fire("Error!", "Failed to delete user.", "error");
                                            }
                                        }
                                    }}
                                >
                                    Delete user
                                </Button>
                                <Premissions values={{ ...userPermissions[user._id] } || {}} setValues={(newPermissions) => handleEditUserPermissions(user._id, newPermissions)} texts={texts} />
                            </div>
                        </CollapsableBox>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UsersList;
